import cn from 'classnames'
import BaseFlyout, {
  BaseFlyoutProps,
} from 'ext-ui/components/BaseFlyout/BaseFlyout'
import React, { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import LoadingRightFlyoutContent from 'src/components/LoadingRightFlyoutContent/LoadingRightFlyoutContent'
import { useTranslate } from 'src/localization/Trns'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

const FiltersFlyoutContent = React.lazy(() => import('./FiltersFlyoutContent'))

import style from './FiltersFlyout.style'

type FiltersFlyoutProps = BaseFlyoutProps & {
  onReset: () => void
  onSave?: () => void
  filters: React.ReactElement
  loading?: boolean
  allYourPagePath?: string
  resultsCount?: number
}

export default function FiltersFlyout(props: FiltersFlyoutProps): ReactElement {
  const { className = '', isOpen, onClose, title } = props
  const { analytics } = useAnalyticsContext()
  const translate = useTranslate()

  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  const screenName = {
    screen: `${calculatedBackgroundLocation.pathname}${props.allYourPagePath}`,
  }

  return (
    <BaseFlyout
      className={cn('FiltersFlyout', className)}
      isOpen={isOpen}
      variant="focus-background"
      onClose={() => {
        onClose()
        analytics?.track('filter flyout - click out', screenName)
      }}
      css={style}
      title={title}
      aria-label={translate('Filters')}
    >
      <React.Suspense fallback={<LoadingRightFlyoutContent />}>
        <FiltersFlyoutContent {...props} />
      </React.Suspense>
    </BaseFlyout>
  )
}
